import CCMRTracking from './CCMRTracking.container';

export default CCMRTracking;
